export default __webpack_public_path__ + "static/media/capitalFinance.2b0c9de5.mp4";